import { render, staticRenderFns } from "./pre-notification-popover.vue?vue&type=template&id=3709e9d2&scoped=true"
import script from "./pre-notification-popover.vue?vue&type=script&lang=ts"
export * from "./pre-notification-popover.vue?vue&type=script&lang=ts"
import style0 from "./pre-notification-popover.vue?vue&type=style&index=0&id=3709e9d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3709e9d2",
  null
  
)

export default component.exports